import makeApiRequest from './makeApiRequest';

const apiRequest = makeApiRequest();

export const getBox = () => {
    return apiRequest.get('/box');
};

export const createBox = () => {
    return apiRequest.post('/box');
};

export const closeBox = () => {
    return apiRequest.delete('/box');
};

export const getBoxes = () => {
    return apiRequest.get('/boxes');
};

export const getItems = (boxId) => {
    return apiRequest.get('/boxes/' + boxId + '/items');
};

export const addItem = (boxId, itemId) => {
    return apiRequest.post('/boxes/' + boxId + '/items', {item_id: itemId});
};

export const getBox2 = () => {
    return apiRequest.get('/box2');
};
export const addItem2 = (boxId, data) => {
    return apiRequest.post('/boxes2/' + boxId + '/items', data );
};
export const getItems2 = (boxId) => {
    return apiRequest.get('/boxes2/' + boxId + '/items');
};

export default {
    getBox,
    createBox,
    closeBox,
    getBoxes,
    getItems,
    addItem,
    getBox2,
    addItem2,
    getItems2
};